export function toTitleCase(str) {
  const titleCase = str?.toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");

  return titleCase;
}

export function toUpperCaseFirst(str) {
  const titleCase = str?.charAt(0).toUpperCase() + str?.slice(1);

  return titleCase;
}

export function toUpperCase(str) {
  const upperCase = str?.toUpperCase();

  return upperCase;
}

export function toLowerCase(str) {
  const lowerCase = str?.toLowerCase();

  return lowerCase;
}

export const formatName = (fullName) => {
  if (!fullName) return "";
  const words = fullName.split(" ");
  const firstWord = words.shift().toUpperCase(); // First word fully uppercase
  const rest = words
    .map(
      (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() // Title case
    )
    .join(" ");
  return [firstWord, rest].filter(Boolean).join(" ");
};

export const toSmartTitleCase = (text) => {
  if (!text) return "";

  const smallWords = [
    "a",
    "an",
    "the",
    "and",
    "but",
    "or",
    "nor",
    "for",
    "so",
    "yet",
    "as",
    "at",
    "by",
    "in",
    "of",
    "on",
    "per",
    "to",
    "up",
    "via",
    "with",
    "over",
    "from",
    "into",
    "onto",
    "upon",
  ];

  return text
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      // Always capitalize first word
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }

      // Keep small words lowercase
      if (smallWords.includes(word)) {
        return word;
      }

      // Capitalize everything else
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};
